import { Box } from '@chakra-ui/react';

import VibeCodeButton from './VibeCodeButton';
import { useDevSandbox } from '../DevSandboxProvider';

const MerlinToggleButton = () => {
  const { merlin } = useDevSandbox();

  return (
    <Box data-tour="merlin-ai" display="inline-flex">
      <VibeCodeButton isActive={merlin.isOpen} onClick={merlin.onToggle} />
    </Box>
  );
};

export default MerlinToggleButton;
